import React from "react";
import PropTypes from "prop-types";
import { Icon as MaterialIcon } from "@material-ui/core";
import "./Icon.scss";
import clsx from "clsx";

export const Icon = ({
  className = "",
  color = "",
  size = "lg",
  type,
  ...props
}) => {
  return (
    <MaterialIcon
      className={clsx("hireart-ds-icon", size, className)}
      style={{ color }}
      {...props}
    >
      {type}
    </MaterialIcon>
  );
};

Icon.propTypes = {
  className: PropTypes.string,
  color: PropTypes.string,
  size: PropTypes.oneOf(["lg", "md", "sm", "xs"]),
  type: PropTypes.string.isRequired,
};

